// eslint-disable-next-line
const formatAmount = (amount) => {
  const num = Number(amount);
  if (!num && num !== 0) return '-';

  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
};

export default formatAmount;
